// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"65ae718a","165":"dabe4a18","453":"90369533","796":"c3a32059"}[chunkId] + ".chunk.js";
};